import { onMounted, onBeforeUnmount, nextTick } from 'vue'
import { useRouter } from 'vue-router'

export default function useAutoSendHeight (sendHeight = () => undefined) {
  let resizeObserver = null
  let mutationObserver = null

  const setupObservers = () => {
    // Observa mudanças no tamanho do body
    resizeObserver = new ResizeObserver(() => {
      sendHeight()
    })
    resizeObserver.observe(document.body)

    // Observa mudanças no DOM (adição/remoção de elementos)
    mutationObserver = new MutationObserver(() => {
      sendHeight()
    })
    mutationObserver.observe(document.body, {
      childList: true,
      subtree: true,
    })
  }

  const cleanupObservers = () => {
    resizeObserver?.disconnect()
    mutationObserver?.disconnect()
  }

  onMounted(() => {
    sendHeight() // altura inicial
    setupObservers()
  })

  onBeforeUnmount(() => {
    cleanupObservers()
  })

  // Também observa mudanças de rota (SPA)
  const router = useRouter()
  router.afterEach(() => {
    nextTick(() => {
      setTimeout(() => {
        sendHeight()
      }, 50)
    })
  })
}
